import { Box, LazyImage } from "../Styled/Elements";
import { BsJustify, BsX } from "react-icons/bs";
import { Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import { LogoEn } from "../Styled/AllImages";
import LangChangeButton from "../../Languages/LangChangeButton";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const WorkshopHeader = ({ sidebarStatus, setSidebarStatus }) => {
  const navigate = useNavigate(); 
  const [isSticky, setIsSticky] = useState(false);

  const handleToggle = () => {
    setSidebarStatus(!sidebarStatus);
  };

  const handleSignOut = () => {
    localStorage.removeItem("participant_data");
    navigate("/workshop-participants");
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <WorkshopHeaderContainer
        className={`${isSticky ? "sticky" : ""} container-fluid`}
      >
        <Container>
          <Box className="nav-bar">
            <Box className="d-flex">
              <span className="toggleBtn" onClick={handleToggle}>
                {sidebarStatus ? <BsX size={30} /> : <BsJustify size={30} />}
              </span>
              <LazyImage className="logo" src={LogoEn} />
            </Box>
            <Box className="d-flex align-items-center gap-2 relative">
                <Box className="whtLngWrapper d-flex align-items-center justify-content-center">
                    <LangChangeButton />
                </Box>

                <Box className="relative">
                    <button
                        type="button"
                        onClick={handleSignOut}
                        className="px-4 py-2 border rounded hover:bg-gray-100"
                    >
                        Sign Out
                    </button>
                </Box>
            </Box>
          </Box>
        </Container>
      </WorkshopHeaderContainer>
    </>
  );
};

export default WorkshopHeader;

const WorkshopHeaderContainer = styled.div`
  height: 94px;
  width: calc(100% - 270px);
  position: fixed;
  top: 0;
  right: 0;
  -webkit-transition: all 0.3s ease-out 0s;
  transition: all 0.3s ease-out 0s;
  background: var(--white);
  border-bottom: 1px solid var(--border);
  z-index: 1001;
  height: 94px;
  body.rtl & {
    right: unset;
    left: 0;
  }
  .nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .logo {
    width: 179px;
    cursor: pointer;
    span {
      width: 100%;
    }
    img {
      width: 179px;
      height: auto;
      -webkit-transition: all 0.3s ease-out 0s;
      transition: all 0.3s ease-out 0s;
    }
  }
  /* &.sticky {
    background: var(--white);
    box-shadow: 0px 3px 10px #07758473;
    z-index: 200;
    .nav-bar {
      border: none;
    }
    .logo {
      svg {
        width: 80px;
        height: auto;
      }
    }
  } */
  .toggleBtn {
    display: none;
  }
  .whtLngWrapper {
    gap: 7px;
  }
  .headerBtn {
    background-color: var(--themeColor);
  }

  .Social-links {
    display: flex;
    gap: 12px;
    cursor: pointer;
  }
  .logo {
    display: none;
  }

  @media (max-width: 1199px) {
    .nav-bar button span {
      font-size: 14px;
    }
  }
  @media (max-width: 992px) {
    width: 100%;
    .logo {
      display: block;
    }
  }
`;
